import request from '@/api/request'
import store from '@/store'

export const mbcImportWaitingTimeout = 90000

// Fixed: Renamed from resolveHeaders to getHeaders to match usage below
const getHeaders = () => {
  const region = store.getters.region || store.getters.defaultRegion
  const brand = store.getters.brand || store.getters.defaultBrand
  return {
    'X-Brand': brand || '',
    'X-Region': region || '',
  }
}

export function mbcImport(formData) {
  return request({
    url: '/mbcimport/v1',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData,
    timeout: mbcImportWaitingTimeout,
  })
}

export function mbcListLicenseProfileBundles(data) {
  return request({
    url: '/mbcInformation/licenseProfileBundles',
    method: 'post',
    data: data
  })
}

export function mbcListImportCapableProductTasks() {
  return request({
    url: '/mbcInformation/mbcImportTask/list',
    method: 'get'
  })
}

export function mbcListImportCapableProductPolicy() {
  return request({
    url: '/mbcInformation/mbcImportTask/config',
    method: 'get'
  })
}

export function mbcCapableProductTaskConfig(data) {
  return request({
    url: '/mbcInformation/mbcImportTask/config/' + data,
    method: 'post'
  })
}

export function mbcListStartOfProductions() {
  return request({
    url: '/mbcInformation/startOfProductions',
    method: 'get'
  })
}

export function mbcGetSops() {
  return request({
    url: '/mbcInformation/getSops',
    method: 'get'
  })
}

export function pmslistArticles() {
  return request({
    url: '/pmsInformation/getArticles',
    method: 'get',
    headers: getHeaders()
  })
}

export function pmsDeleteArticles(articleId) {
  return request({
    url: '/pmsInformation/deleteArticle/' + articleId,
    method: 'post',
    headers: getHeaders()
  })
}


export function pmslistProducts() {
  return request({
    url: '/pmsInformation/getProducts',
    method: 'get',
    headers: getHeaders()
  })
}

export function pmsDeleteProducts(productId) {
  return request({
    url: '/pmsInformation/deleteProduct/' + productId,
    method: 'post',
    headers: getHeaders()
  })
}

export function mbcGetSopByLpId(lpId) {
  return request({
    url: '/mbcInformation/startOfProductionsByLpId/' + lpId,
    method: 'get'
  })
}

export function mbcGetFunctionsByLpId(lpId) {
  return request({
    url: '/mbcInformation/functionsByLpId/' + lpId,
    method: 'get'
  })
}

export function mbcGetFuncFsIdBySopId(sopId) {
  return request({
    url: '/mbcInformation/startOfProduction/' + sopId,
    method: 'get'
  })
}

export function pmsGetProducts(articleId) {
  return request({
    url: '/pmsInformation/getProducts/' + articleId,
    method: 'get',
    headers: getHeaders()
  })
}

export function pmsGetScenarios(articleId) {
  return request({
    url: '/pmsInformation/getScenarios/' + articleId,
    method: 'get',
    headers: getHeaders()
  })
}

export function pmsGetActivations(productId) {
  return request({
    url: '/pmsInformation/getActivations/' + productId,
    method: 'get',
    headers: getHeaders()
  })
}
